function removeDiacritics(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function compare(str1, str2, { caseInsensitive = true, ignoreDiacritics = false, useTrim = true } = {}) {
    let processedStr1 = str1;
    let processedStr2 = str2;
    if (ignoreDiacritics) {
        processedStr1 = removeDiacritics(processedStr1);
        processedStr2 = removeDiacritics(processedStr2);
    }
    if (caseInsensitive) {
        processedStr1 = processedStr1.toLowerCase();
        processedStr2 = processedStr2.toLowerCase();
    }
    if (useTrim) {
        processedStr1 = processedStr1.trim();
        processedStr2 = processedStr2.trim();
    }
    return processedStr1 === processedStr2;
}
export function compareStrings(str1, str2, options) {
    return Array.isArray(str2)
        ? str2.some(str => compare(str1, str, options))
        : compare(str1, str2, options);
}
